/** A template renderer's stacked blocks, inset in the Template changes panel. */
export const changesetStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  minWidth: 0,
  padding: '12px 14px',
};

// A modal's content row sizes a child to its content; the compare and the preview size their blocks
// to this column, so it takes the whole row.
export const modalBodyStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  width: '100%',
  minWidth: 0,
};

/** A changed part's title over its name, in the part rows and the preview's list of changes. */
export const partTextStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  minWidth: 0,
};
